import { Popover, Button, message, Tooltip } from "antd";
import {
  PhoneFilled,
  WhatsAppOutlined,
  CopyOutlined,
  MessageOutlined
} from "@ant-design/icons";
import { useState } from "react";
import "../../style/dashboard/ContactActions.css";

interface ContactActionsProps {
  contactNumber?: string;
}

const ContactActions: React.FC<ContactActionsProps> = ({ contactNumber }) => {
  const [open, setOpen] = useState(false);

  const mobile = contactNumber?.replace(/\+/g, "") || "";

  const closePopover = () => setOpen(false);

  const copyNumber = async () => {
    if (!mobile) return;
    await navigator.clipboard.writeText(`+${mobile}`);
    message.success("Mobile number copied");
    closePopover();
  };

  // WhatsApp App detection + fallback
  const openWhatsApp = () => {
    if (!mobile) return;

    closePopover();
    const start = Date.now();

    // Try WhatsApp app
    window.location.href = `whatsapp://send?phone=${mobile}`;

    // Fallback to web
    setTimeout(() => {
      if (Date.now() - start < 1500) {
        window.open(`https://wa.me/${mobile}`, "_blank", "noopener,noreferrer");
      }
    }, 1200);
  };

  const content = (
    <div className="contact-popup animated">
      <Button
        type="primary"
        icon={<PhoneFilled />}
        href={`tel:+${mobile}`}
        onClick={closePopover}
      >
        Call
      </Button>

      <Button
        icon={<WhatsAppOutlined style={{ color: "green" }} />}
        onClick={openWhatsApp}
      >
        WhatsApp
      </Button>

      <Button
        icon={<MessageOutlined />}
        href={`sms:${mobile}`}
        onClick={closePopover}
      >
        SMS
      </Button>

      <Tooltip title="Copy number">
        <Button icon={<CopyOutlined />} onClick={copyNumber}>
          Copy
        </Button>
      </Tooltip>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      placement="topRight"
      open={open}
      onOpenChange={setOpen}
      getPopupContainer={() => document.body}
      overlayStyle={{ zIndex: 20000 }}
      destroyTooltipOnHide
    >
      <PhoneFilled className="phone-trigger" />
    </Popover>
  );
};

export default ContactActions;
